import React from "react"
import PropTypes from 'prop-types'
import Card from './Card'

const MvpsSection = props => {
  const { items } = props

  return (
    <div>
      {items.length > 0 && (
        <>
          <tm-trailblazers-a>
            {
              items.map( (item, index) => (
                <Card key={`mvp-card-item-${index}`} data={item} />
              ))
            }
          </tm-trailblazers-a>
        </>
      )}
    </div>
  )
}

MvpsSection.propTypes = {
  items: PropTypes.array.isRequired
}

export default MvpsSection